import type {
  CosmeticProfileEntry,
  CosmeticProfileResponse
} from '@/features/profiles/types/avatar-catalog'

export function getCosmeticUrlsForIds(
  list: CosmeticProfileEntry[],
  ids: {
    avatarId: number | null
    frameId: number | null
    backgroundId: number | null
  }
): {
  backgroundUrl: string | null
  avatarUrl: string
  frameUrl: string | null
} {
  const urlForId = (id: number | null): string | null => {
    if (id == null) return null
    const c = list.find(x => x.id === id)
    return c?.image?.file?.url ?? null
  }

  return {
    backgroundUrl: urlForId(ids.backgroundId),
    avatarUrl: urlForId(ids.avatarId) ?? '/placeholders/avatar.png',
    frameUrl: urlForId(ids.frameId)
  }
}

export function getCosmeticPreviewUrlsFromProfile(
  data: CosmeticProfileResponse | undefined
):
  | {
      backgroundUrl: string | null
      avatarUrl: string
      frameUrl: string | null
    }
  | undefined {
  if (!data) return undefined
  return getCosmeticUrlsForIds(data.cosmetics, {
    avatarId: data.active_avatar_id,
    frameId: data.active_frame_id,
    backgroundId: data.active_background_id
  })
}
